var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.notification && _vm.notification.id)?_c('v-snackbar',{attrs:{"right":"","color":_vm.notification.type,"timeout":-1},model:{value:(_vm.showNotification),callback:function ($$v) {_vm.showNotification=$$v},expression:"showNotification"}},[_vm._v(" "+_vm._s(_vm.notification.message)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }